import { Device } from './types';

const device: Device = {
  minDevice: '@media (max-width: 320px)',
  mobile: '@media (max-width: 370px)',
  mobileLarge: '@media (max-width: 425px)',
  tablet: '@media (max-width: 768px)',
  tabletLarge: '@media (max-width: 1024px)',
  laptop: '@media (max-width: 1366px)',
  desktop: '@media (max-width: 1440px)',
  maxDevice: '@media (max-width: 1920px)',
};

export default device;
